<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Statistik Products</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index-agent">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Statistik Products</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="form-group form-focus">
                  <div class="btn-group btn-block">
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn btn-block"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span v-if="!isLoadingImage"
                        ><i class="fa fa-download"></i> Download Image</span
                      >
                      <span v-else>...</span>
                    </button>
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn dropdown-toggle dropdown-toggle-split"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        :disabled="isLoadingImage"
                        href="javascript:void(0)"
                        @click.prevent="downloadImagePNG()"
                        >PNG</a
                      >
                      <a
                        class="dropdown-item"
                        :disabled="isLoadingImage"
                        href="javascript:void(0)"
                        @click.prevent="downloadImageJPEG()"
                        >JPEG</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="row filter-row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-4">Brand</label>
                    <div class="col-md-8">
                      <multiselect
                        v-model="selectedContact"
                        id="ajax"
                        label="license_name"
                        track-by="id"
                        :placeholder="'Type to search Brand...'"
                        :multiple="true"
                        open-direction="bottom"
                        :custom-label="customLabel"
                        :options="contactOptions"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :close-on-select="false"
                        :options-limit="300"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="asyncFind"
                        :show-labels="false"
                      >
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <span>{{ option.name }}</span>
                            <span class="custom__remove" @click="remove(option)"
                              >❌</span
                            >
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div
                            class="multiselect__clear"
                            v-if="selectedContact.length"
                            @mousedown.prevent.stop="clearAll(props.search)"
                          ></div>
                        </template>
                        <span slot="noResult">Oops! No elements found.</span>
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-4">Product</label>
                    <div class="col-md-8">
                      <multiselect
                        v-if="selectedContact.length"
                        v-model="selectedProduct"
                        id="ajax"
                        label="name"
                        track-by="id"
                        :placeholder="'Type to search Product...'"
                        :multiple="true"
                        open-direction="bottom"
                        :custom-label="customLabel"
                        :options="productOptions"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :close-on-select="false"
                        :options-limit="300"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="asyncFindProduct"
                        :show-labels="false"
                      >
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <span>{{ option.name }}</span>
                            <span class="custom__remove" @click="remove(option)"
                              >❌</span
                            >
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div
                            class="multiselect__clear"
                            v-if="selectedProduct.length"
                            @mousedown.prevent.stop="clearAll(props.search)"
                          ></div>
                        </template>
                        <span slot="noResult">Oops! No elements found.</span>
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row filter-row">
                <div class="col-md-3">
                  <div class="form-group form-focus">
                    <input
                      v-model="columnFilters.start_date"
                      class="form-control floating"
                      type="date"
                    />
                    <label class="focus-label sr-only">From</label>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group form-focus">
                    <input
                      v-model="columnFilters.end_date"
                      class="form-control floating"
                      type="date"
                    />
                    <label class="focus-label sr-only">To</label>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group form-focus">
                    <a
                      href="javascript:void(0)"
                      id="searchData"
                      @click.prevent="searchData"
                      class="btn btn-success btn-block"
                      >Search</a
                    >
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group form-focus">
                    <a
                      href="javascript:void(0)"
                      @click.prevent="clearData"
                      class="btn btn-secondary btn-block"
                      >Clear</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style="text-align: center; margin-top: 20px;"
            v-if="isCheckBrandProduct"
          >
            Silakan pilih Brand dan Produk untuk melihat laporan.
          </div>

          <div v-show="isCheckBrandProduct == false">
            <template v-if="isLoadingData">
              <div class="row">
                <div class="col-md-12">
                  <Skeleton :count="1" />
                </div>
              </div>
            </template>

            <div
              :style="
                isLoadingData ? 'visibility: hidden;' : 'visibility: visible'
              "
              ref="downloadImage"
            >
              <div class="row">
                <div class="col-md-12">
                  <TotalKeywords
                    v-if="cloudData.length > 0"
                    :propCloudData="cloudData"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="card card__custom-height">
                    <div class="card-body ">
                      <TotalScrapeMarketplace
                        :propSeries="series1"
                        :propChartLabel="chartLabel1"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card card__custom-height">
                    <div class="card-body ">
                      <apexchart
                        ref="barchart"
                        :options="chartOptions2"
                        :series="series2"
                        type="bar"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <TotalStatusPerMP
                        :propSeries3="seriesShopee"
                        mpId="shopee"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <TotalStatusPerMP
                        :propSeries3="seriesTokopedia"
                        mpId="tokopedia"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <TotalStatusPerMP
                        :propSeries3="seriesLazada"
                        mpId="lazada"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <TotalStatusPerMP
                        :propSeries3="seriesBukalapak"
                        mpId="bukalapak"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import TotalScrapeMarketplace from "./components/totalScrapeMarketplace";
import TotalStatusPerMP from "./components/totalStatusPerMP";
import TotalKeywords from "./components/totalKeywords";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import VueApexCharts from "vue-apexcharts";
import { Skeleton } from "vue-loading-skeleton";

import { toPng, toJpeg } from "html-to-image";

export default {
  name: "index",
  components: {
    LayoutHeader,
    LayoutSidebar,
    TotalScrapeMarketplace,
    TotalStatusPerMP,
    TotalKeywords,
    Multiselect,
    apexchart: VueApexCharts,
    Skeleton
  },
  data() {
    return {
      isLoadingImage: false,
      selectedProduct: [],
      productOptions: [],
      productListParam: {
        brand_id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      columnFilters: {
        brand_id: "",
        product_id: "",
        start_date: "",
        end_date: ""
      },
      isLoading: false,
      series1: [],
      chartLabel1: [],
      series2: [
        {
          data: []
        }
      ],
      chartOptions2: {
        chart: {
          height: "100%",
          type: "bar"
        },
        colors: ["#E31E52", "#fccd00", "#03AC0E", "#EE4D2D", "#1890FF"],
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          formatter: function(seriesName, opts) {
            return `${seriesName} ${[
              opts.w.globals.series[0][opts.seriesIndex]
            ]}`;
          },
          fontSize: "12px"
        },
        xaxis: {
          categories: ["Raw", "In Progress", "Need Review", "Reopen", "Closed"],
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        },
        noData: {
          text: "Tidak ada data yang tersedia"
        },
        title: {
          text: "Total Scrape Semua Status",
          style: {
            fontFamily: "CircularStd",
            fontSize: "20px",
            fontWeight: 500
          }
        },
        tooltip: {
          followCursor: true,
          x: {
            show: false
          },
          y: {
            formatter: function(
              value,
              { series, seriesIndex, dataPointIndex, w }
            ) {
              return value;
            },
            title: {
              formatter: (seriesName, series) => {
                return `${series.w.globals.labels[series.dataPointIndex]}`;
              }
            }
          }
        }
      },
      seriesShopee: [],
      seriesTokopedia: [],
      seriesLazada: [],
      seriesBukalapak: [],
      cloudData: [],
      isLoadingData: false,
      isCheckBrandProduct: true,
      isDataLoad: false
    };
  },
  async created() {
    this.columnFilters.brand_id = (await this.$route.query.brand_id)
      ? this.$route.query.brand_id
      : "";
    this.columnFilters.product_id = (await this.$route.query.product_id)
      ? this.$route.query.product_id
      : "";

    await this.asyncFind("");
  },
  watch: {
    selectedProduct: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedProduct = val;
        }
        if (val.length == 1) {
          this.columnFilters.product_id = val[0].id;
          // this.searchData();
        } else {
          this.columnFilters.product_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
          // this.asyncFindProduct()
        }
        if (val.length == 1) {
          this.productOptions = [];
          this.selectedProduct = [];
          this.columnFilters.brand_id = val[0].id;
          this.asyncFindProduct();
          // this.searchData();
        } else {
          this.productOptions = [];
          this.selectedProduct = [];
          this.columnFilters.brand_id = "";
          // this.searchData();
        }
      },
      deep: true
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    async clearData() {
      this.columnFilters.brand_id = "";
      this.columnFilters.product_id = "";
      this.columnFilters.start_date = "";
      this.columnFilters.end_date = "";
      this.selectedContact = [];

      this.isCheckBrandProduct = true;
      this.isDataLoad = false;
    },
    async searchData() {
      if (
        this.columnFilters.brand_id == "" ||
        this.columnFilters.product_id == ""
      ) {
        this.$fire({
          title: "Error",
          text: "Silakan pilih Brand dan Produk untuk melihat laporan.",
          type: "error",
          timer: 2000
        });
        return;
      }

      this.isCheckBrandProduct = false;
      this.getData();
    },
    async getData() {
      this.isLoadingData = true;

      this.cloudData.length = 0;
      this.series1.length = 0;
      this.chartLabel1.length = 0;
      this.series2[0].data.length = 0;
      this.seriesShopee.length = 0;
      this.seriesTokopedia.length = 0;
      this.seriesLazada.length = 0;
      this.seriesBukalapak.length = 0;

      this.getTotalKeywords();
      this.getTotalScrapeMP();
      this.getTotalScrapeStatus();
      this.getTotalStatusShopee();
      this.getTotalStatusTokopedia();
      this.getTotalStatusLazada();
      this.getTotalStatusBukalapak();

      this.isLoadingData = false;
      this.isDataLoad = true;
    },
    async getTotalScrapeMP() {
      await this.$store
        .dispatch("agent/getTotalScrapeMP", this.columnFilters)
        .then(response => {
          const { data } = response;
          data.forEach(element => {
            this.series1.push(element.total);
            this.chartLabel1.push(element.marketplace);
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getTotalScrapeStatus() {
      await this.$store
        .dispatch("agent/getTotalScrapeStatus", this.columnFilters)
        .then(response => {
          let series = [];
          let labels = [];
          const { data } = response;
          data.forEach(element => {
            series.push(element.total);
            labels.push(element.status);
          });
          this.updateChart(series, labels);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateChart(series) {
      series.every(item => item < 1) ? (series = []) : series;
      this.$refs.barchart.appendData([{ data: series }]);
    },
    async getTotalStatusShopee() {
      let dataParams = {
        brand_id: this.columnFilters.brand_id,
        product_id: this.columnFilters.product_id,
        start_date: this.columnFilters.start_date,
        end_date: this.columnFilters.end_date,
        mp_id: "shopee"
      };

      await this.$store
        .dispatch("agent/totalStatusPerMP", dataParams)
        .then(response => {
          const { data } = response;
          data.forEach(element => {
            this.seriesShopee.push(element.total);
          });
        })
        .catch(error => {
          reject(err);
        });
    },
    async getTotalStatusTokopedia() {
      let dataParams = {
        brand_id: this.columnFilters.brand_id,
        product_id: this.columnFilters.product_id,
        start_date: this.columnFilters.start_date,
        end_date: this.columnFilters.end_date,
        mp_id: "tokopedia"
      };

      await this.$store
        .dispatch("agent/totalStatusPerMP", dataParams)
        .then(response => {
          const { data } = response;
          data.forEach(element => {
            this.seriesTokopedia.push(element.total);
          });
        })
        .catch(error => {
          reject(err);
        });
    },
    async getTotalStatusLazada() {
      let dataParams = {
        brand_id: this.columnFilters.brand_id,
        product_id: this.columnFilters.product_id,
        start_date: this.columnFilters.start_date,
        end_date: this.columnFilters.end_date,
        mp_id: "lazada"
      };

      await this.$store
        .dispatch("agent/totalStatusPerMP", dataParams)
        .then(response => {
          const { data } = response;
          data.forEach(element => {
            this.seriesLazada.push(element.total);
          });
        })
        .catch(error => {
          reject(err);
        });
    },
    async getTotalStatusBukalapak() {
      let dataParams = {
        brand_id: this.columnFilters.brand_id,
        product_id: this.columnFilters.product_id,
        start_date: this.columnFilters.start_date,
        end_date: this.columnFilters.end_date,
        mp_id: "bukalapak"
      };

      await this.$store
        .dispatch("agent/totalStatusPerMP", dataParams)
        .then(response => {
          const { data } = response;
          data.forEach(element => {
            this.seriesBukalapak.push(element.total);
          });
        })
        .catch(error => {
          reject(err);
        });
    },
    async getTotalKeywords() {
      await this.$store
        .dispatch("agent/totalKeywords", this.columnFilters)
        .then(res => {
          const { data } = res;
          data.forEach(item => {
            this.cloudData.push({
              name: item.keywords_name,
              value: item.total_result
            });
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    asyncFindProduct(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.productListParam.name = query;
      // console.log("selectedContact", this.selectedContact);
      this.productListParam.brand_id = this.selectedContact[0].id;
      var filterProductId = this.columnFilters.product_id;
      this.$store
        .dispatch("brandProduct/listAgent", this.productListParam)
        .then(response => {
          this.isLoading = false;
          this.productOptions = response.data.data;
          if (filterProductId) {
            this.productOptions.forEach(item => {
              if (item.id == filterProductId) {
                this.selectedProduct.push(item);
              }
            });
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/listAgent", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          if (this.columnFilters.brand_id) {
            this.contactOptions.forEach(item => {
              if (item.id == this.columnFilters.brand_id) {
                this.selectedContact.push(item);
              }
            });
            this.asyncFindProduct();
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    async downloadImagePNG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (this.isDataLoad == false) {
        this.$fire({
          title: "Error",
          text: "Silakan pilih Brand dan Produk kemudian Search dahulu.",
          type: "error",
          timer: 2000
        });
        return;
      }

      if (el === null) {
        return;
      }

      this.isLoadingImage = true;

      await toPng(el, { backgroundColor: "#f7f7f7" })
        .then(dataUrl => {
          const link = document.createElement("a");
          link.download = `statistik-products-${unixTime}.png`;
          link.href = dataUrl;
          link.click();
        })
        .catch(err => {
          console.log(err);
        });

      this.isLoadingImage = false;
    },
    async downloadImageJPEG() {
      const el = this.$refs.downloadImage;
      const now = new Date();
      const unixTime = Math.floor(now.getTime() / 1000);

      if (this.isDataLoad == false) {
        this.$fire({
          title: "Error",
          text: "Silakan pilih Brand dan Produk kemudian Search dahulu.",
          type: "error",
          timer: 2000
        });
        return;
      }

      if (el === null) {
        return;
      }

      this.isLoadingImage = true;

      await toJpeg(el, { backgroundColor: "#f7f7f7" })
        .then(dataUrl => {
          const link = document.createElement("a");
          link.download = `statistik-products-${unixTime}.jpeg`;
          link.href = dataUrl;
          link.click();
        })
        .catch(err => {
          console.log(err);
        });

      this.isLoadingImage = false;
    }
  }
};
</script>

<style>
.card__custom-height.card {
  min-height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/monitoring/summary/indexAgent.vue